export const SERVER_HOST_QR = 'https://dev.lfs.rest/api/v4/'
export const DEFAULT_LANG = 'ru'
